import { distanceTo, insideCircle } from "geolocation-utils";

import { Road } from "services";
import { IBestBikingRoad, Prettify, Iterable } from "types";

type Props = {
  radius: number;
  roads: Iterable<IBestBikingRoad>[];
  route: number[][];
};

export const roadsIncludesInRoute = ({
  roads,
  route,
  radius,
}: Prettify<Props>) => {
  // console.log({ radius });

  const road = Road.fromPoints(route);
  const circles = road.circles({ radius, gaps: [10, 10] });

  const includedRoads: { lat: number; lng: number }[][] = [];

  for (const road of roads) {
    const points: { lat: number; lng: number }[] = [];
    const coordinates = road.geometry.coordinates;

    coordinates.forEach((coord) => {
      const isInsideCircle =
        circles.filter((circle) => {
          return insideCircle(
            { lat: coord.lat, lon: coord.lng },
            { lat: circle.lat, lon: circle.lng },
            radius * 1000
          );
        }).length > 0;

      if (isInsideCircle) {
        points.push(coord);
      }
    });

    const minimum = coordinates.length / 2;

    if (points.length >= minimum) {
      includedRoads.push(coordinates);
    }
  }

  return { includedRoads, circles };
};

type GetRoadDirectionProps = {
  start: { lat: number; lng: number };
  coordinates: { lat: number; lng: number }[];
  finish: { lat: number; lng: number };
};

export const getRoadDirection = ({
  start,
  finish,
  coordinates,
}: Prettify<GetRoadDirectionProps>) => {
  const [roadStart, roadFinish] = [
    coordinates[0],
    coordinates[coordinates.length - 1],
  ];

  const [startToStart, startToFinish] = [
    distanceTo(roadStart, start),
    distanceTo(roadStart, finish),
  ];
  const [finishToStart, finishToFinish] = [
    distanceTo(roadFinish, start),
    distanceTo(roadFinish, finish),
  ];

  if (startToStart <= startToFinish && finishToStart <= finishToFinish) {
    return [...coordinates].reverse();
  }

  return coordinates;
};

type NearesPointOnRouteProps = {
  points: { lat: number; lng: number }[]; // [start, finish]
  coordinates: { lat: number; lng: number }[];
};

export const findNearestPointsOnRoute = ({
  points,
  coordinates,
}: Prettify<NearesPointOnRouteProps>) => {
  const [start, finish] = points;

  // const compare = (a: number, b: number) => {
  //   return a - b;
  // };

  const distancesToStart = coordinates.map((c) => distanceTo(start, c));
  const distancesToFinish = coordinates.map((c) => distanceTo(finish, c));

  const minDistanceToStart = Math.min(...distancesToStart);
  const minDistanceToFinish = Math.min(...distancesToFinish);

  // console.log({ minDistanceToStart, minDistanceToFinish });

  const startIndex = distancesToStart.indexOf(minDistanceToStart);
  const finishIndex = distancesToFinish.indexOf(minDistanceToFinish);

  // console.log({ distancesToStart, distancesToFinish });

  // const distancesToStartSorted = [...distancesToStart].sort(compare);
  // const distancesToFinishSorted = [...distancesToFinish].sort(compare);

  // console.log({ start: distancesToStartSorted[0] });

  // const startIndex = distancesToStart.findIndex(
  //   (d) => d === distancesToStartSorted[0]
  // );
  // const finishIndex = distancesToFinish.findIndex(
  //   (d) => d === distancesToFinishSorted[0]
  // );

  return [startIndex, finishIndex];
};

type IncludePoints = {
  points: { lat: number; lng: number }[];
  coordinates: { lat: number; lng: number }[];
};

export const includedPoints = ({
  points,
  coordinates,
}: Prettify<IncludePoints>) => {
  return points.filter(
    (point) =>
      coordinates.filter(
        (coords) => coords.lat === point.lat && coords.lng === point.lng
      ).length > 0
  );
};
